type PlayerTag = {
  tag: 'waiting' | 'inplay' | 'folded' | 'allin' | 'out' | 'sitout' | 'disconnected' | 'observer' | 'foreverout'
}

export type Waiting = PlayerTag & { tag: 'waiting' } // when player joins middle game
export type InPlay = PlayerTag & { tag: 'inplay' } // when player palying game
export type Folded = PlayerTag & { tag: 'folded' } // when player folded in game
export type AllIn = PlayerTag & { tag: 'allin' } // when player put all chips
export type Out = PlayerTag & { tag: 'out' } // when player have zero chips
export type SitOut = PlayerTag & { tag: 'sitout' } // when player skip turn twise in tournament game
export type ForeverOut = PlayerTag & { tag: 'foreverout' } // when player skip turn twise in quick play game
export type Disconnected = PlayerTag & { tag: 'disconnected' } // when player leaves playing game
export type Observer = PlayerTag & { tag: 'observer' } // when player leaves playing tournament and wants to rejoin again or player join after window close in tournament

export type PlayerState = Waiting | InPlay | Folded | AllIn | Out | SitOut | Disconnected | Observer | ForeverOut
